import { UxTheme } from "../globals/globals";
import { logger } from "./console";

/**
 * Sets the user interface theme.
 *
 * @param {UxTheme} theme - The theme to be set. This should be an instance of the UxTheme type.
 *
 * This function does the following:
 * - Sets the theme on the global `window.trumpf.ux.theme` object.
 * - Creates a new style element and appends it to the document head.
 *   This style element sets the CSS variable `--trumpf-ux-theme` to the specified theme.
 * - Dispatches a `uxThemeChange` event on the window object.
 * - Logs a message indicating that the theme has been set.
 */
export const setTheme = (theme: UxTheme) => {
    if (typeof window !== "undefined") {
        const win = window as unknown as Window & {
            trumpf: {
                ux: {
                    theme: UxTheme;
                };
            };
        };
        win.trumpf = win.trumpf || {};
        win.trumpf.ux = win.trumpf.ux || {};
        win.trumpf.ux.theme = theme;
        const styleElement = document.createElement("style");
        styleElement.innerHTML = `:root { --trumpf-ux-theme: ${theme}; }`;
        document.head.appendChild(styleElement);
        const event = new Event("uxThemeChange");
        window.dispatchEvent(event);
        logger.info(`Theme set to ${theme}`);
    }
};
